interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  variant?: 'light' | 'dark';
  className?: string;
}

/**
 * ClosedLoopDiving Logo Component
 *
 * Displays the ClosedLoopDiving brand logo with configurable size and color variants.
 * Features:
 * - Three size options: small (32px), medium (48px), large (64px)
 * - Light variant (white) for dark backgrounds
 * - Dark variant (original) for light backgrounds
 */
export function Logo({
  size = 'medium',
  variant = 'dark',
  className = '',
}: LogoProps) {
  const sizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-12 h-12',
    large: 'w-16 h-16',
  };

  // Logo is white with transparent background
  // Light variant: use as-is (white on dark backgrounds)
  // Dark variant: invert to show on light backgrounds
  const variantStyles = {
    light: {
      background: 'transparent',
      display: 'block' as const,
    },
    dark: {
      filter: 'brightness(0)',  // Makes white logo dark
      background: 'transparent',
      display: 'block' as const,
    },
  };

  return (
    <img
      src="/assets/logo.png"
      alt="ClosedLoopDiving"
      className={`${sizeClasses[size]} ${className}`}
      style={variantStyles[variant]}
    />
  );
}
